import { GroupDTO } from '@wix/package-picker-common';
import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';

interface GridFeatureGroupHeaderProps {
  group: GroupDTO;
}

export const GridFeatureGroupHeader: React.FC<GridFeatureGroupHeaderProps> = ({
  group,
}) => {
  return (
    <Box>
      <Text weight='bold'>
        <Trans i18nKey={group.name} />
      </Text>
    </Box>
  );
};
